import { render } from "./MainPage.vue?vue&type=template&id=29afc204"
import script from "./MainPage.vue?vue&type=script&lang=js"
export * from "./MainPage.vue?vue&type=script&lang=js"

import "./MainPage.vue?vue&type=style&index=0&id=29afc204&lang=scss"

import exportComponent from "/home/runner/work/colordemy-customers/colordemy-customers/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__